<template>
  <div v-if="link" class="tag" :class="[colour, background]">
    <nuxt-link :to="link">{{ text }}</nuxt-link>
  </div>
  <div v-else class="tag" :class="[colour, background]">
    <span>{{ text }}</span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Tag",
  props: {
    text: {
      type: String,
      default: null,
    },
    link: {
      type: String,
      default: "",
    },
    isBanner: {
      type: Boolean,
      default: false,
    },
    isPremium: {
      type: Boolean,
      default: false,
    },
    uuid: {
      type: [String, Number],
      default: "",
    },
    tid: {
      type: [String, Number],
      default: "",
    },
    background: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters("Profile", ["getWatchedSections"]),
    colour() {
      let colour = "gray";
      if (this.isPremium) colour = "brown";
      if (this.isBanner) colour = "black";
      if (
        this.getWatchedSections.find(
          (el) => el === this.uuid + "" || el === this.tid + ""
        )
      ) {
        colour = "red";
      }
      return colour;
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";
.tag {
  font-size: 1rem;
  line-height: 1.4rem;
  font-weight: 600;
  text-transform: uppercase;
  color: $tagColor;
  padding: 0.2rem 0.6rem 0.1rem;
  display: inline-block;
  margin-bottom: 0.75rem;
  text-decoration: none;
  border: 1px solid $tagBorder;

  &:not(:last-child) {
    margin-right: 0.4rem;
  }

  &:last-of-type {
    margin-right: 0;
  }

  &.dark-red {
    color: $dark_red !important;
    border-color: $corporateBlue !important;
  }

  &.dark-red-filled {
    color: $white;
    background: $corporateBlue;
  }

  &.red-filled {
    color: $white;
    background: #ff0000;
  }
  &.gray {
    border-color: #c6d5e0;

    a {
      text-decoration: none;
      color: #383838;
    }
  }

  &.black {
    background: $text;
  }

  &.green {
    background: #008000;
    color: $white;
    a {
      color: $white;
    }
  }
  &.orange {
    background: #ffa500;
    color: $white;
    a {
      color: $white;
    }
  }
  &.brown {
    border-color: $corporateBlue;
    background: $corporateBlue;
    a {
      color: $white;
    }
  }
  &.red {
    border-color: $brightBlue !important;

    a {
      text-decoration: none;
      color: $red;
    }
  }

  &.green {
    border-color: #008000 !important;

    a {
      text-decoration: none;
      color: $white !important;
    }
  }
}

.tag.red {
  border-color: $brightBlue !important;
}

.tag.red a {
  text-decoration: none;
  color: $brightBlue;
}

.tag.brightgreen {
  border-color: $brightGreen !important;
}

.tag.brightgreen a {
  text-decoration: none;
  color: $brightGreen;
}

.tag.brightblue {
  border-color: $brightBlue !important;
}

.tag.brightblue a {
  text-decoration: none;
  color: $brightBlue;
}
</style>
